import { _js } from '@ifixit/localize';
import { useContext } from 'react';
import { FaIcon } from '@ifixit/ui/components/icon';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import { BreakpointsContext } from 'Shared/utils/breakpoints';

const textLinkClass =
   'whitespace-nowrap text-sm font-semibold text-white no-underline transition-colors duration-100 hover:text-brand-400';
const iconClass = 'size-10 flex justify-center items-center';

const trackLoginClick = () => {
   trackAnalyticsCustomEvent({
      eventCategory: 'Header Auth',
      eventAction: 'Log In Header Button - Click',
   });
};

const trackJoinClick = () => {
   trackAnalyticsCustomEvent({
      eventCategory: 'Header Auth',
      eventAction: 'Join Header Button - Click',
   });
};

const AuthIcons = () => {
   const breakpoints = useContext(BreakpointsContext);

   if (breakpoints.isMobileTablet()) {
      return (
         <a href="/Login" aria-label="Log in" onClick={trackLoginClick} className={iconClass}>
            <FaIcon name="user" style="solid" className="text-white size-6" />
         </a>
      );
   }

   return (
      <div className="relative flex items-center justify-between gap-4 mx-2">
         <a href="/Join" id="navSignup" onClick={trackJoinClick} className={textLinkClass}>
            {_js('Join')}
         </a>
         <div className="h-6 w-px shrink-0 bg-gray-700" />
         <a href="/Login" id="navLogin" onClick={trackLoginClick} className={textLinkClass}>
            {_js('Log In')}
         </a>
      </div>
   );
};

export default AuthIcons;
